import { FC } from "react";
import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { StyledMetadata } from "./dropdown-list-item.style";

type Props = {
  kind: MemCommonMentionKind;
  metadata?: Record<string, unknown>;
  showMetadata?: boolean;
};

export const MDSComboboxListItemMetadata: FC<Props> = ({
  kind,
  metadata = {},
  showMetadata = true,
}) => {
  if (!showMetadata) return null;

  const isCollection = kind === MemCommonMentionKind.Collection;
  const isNote = kind === MemCommonMentionKind.Note;
  const noteCount = metadata.noteCount as number | undefined;
  const dateLabel = metadata.dateLabel as string | undefined;
  const description = metadata.description as string | undefined;

  const metadataItems = [];

  // Show count and description for collections using the same logic as ChatInput
  if (isCollection && typeof noteCount === "number") {
    const subtitle = getCollectionSubtitle(noteCount, description);
    if (subtitle) {
      metadataItems.push(subtitle);
    }
  }

  // Show date for notes
  if (isNote && dateLabel) {
    metadataItems.push(dateLabel);
  }

  if (metadataItems.length === 0) return null;

  return <StyledMetadata>{metadataItems.join(" • ")}</StyledMetadata>;
};

// Helper function to generate collection subtitle following the same logic as getCollectionItemSubtitle
const getCollectionSubtitle = (noteCount: number, description?: string): string | null => {
  if (noteCount === 0) {
    if (description) {
      return description;
    }

    return "No notes";
  }

  const countText = `${noteCount} ${noteCount === 1 ? "note" : "notes"}`;
  if (!description) {
    return countText;
  }

  return `${countText} • ${description}`;
};
